import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { useTableMaxHeight } from '@anytag/shared-hooks';
import { YoutubeAnalyticsTrendPayload } from '@anytag/graphql';
import { YoutubeTrendPostDetailsModal } from '@anytag/shared-molecules';
import { TrendingPostsTabType } from '../TrendingPostsFilter';
import { useTrendingPostsTable } from './hooks';

export interface TrendingPostsListProps extends TableData<YoutubeAnalyticsTrendPayload> {
  tab: TrendingPostsTabType;
}

export const TrendingPostsList = ({ tab, loading, data = [] }: TrendingPostsListProps) => {
  const { columns } = useTrendingPostsTable({ tab });
  const { offsetRef, defaultTableMaxHeight } = useTableMaxHeight();

  return (
    <>
      <TableV2
        data={data}
        loading={loading}
        columns={columns}
        noTopBorderRadius
        stickyHeader
        hasBorder
        ref={offsetRef}
        maxHeight={defaultTableMaxHeight}
      />

      <YoutubeTrendPostDetailsModal posts={data.map(({ id }) => ({ id: String(id) }))} />
    </>
  );
};
